module.exports = __webpack_public_path__ + "img/iconReadDetail.09deb2d4.svg";